import { ActionTypes } from '../actions'

const {
  CHANGE_FILTER,
  RESET_FILTERS,
  FETCH_INITIAL_DATA_RECEIVED
} = ActionTypes

const initialFilters = {
  leagueName: '',
  status: [],
  tour: 'all',
  startDate: '',
  endDate: '',
  location: {
    coords: {lat: '', lng: ''},
    radius: '',
  },
  currentLocation: '',
}
const filters = (state = initialFilters, action) => {
  if (!state.leagueName) {
    state = {
      ...initialFilters,
      ...state,
    }
  }

  switch (action.type) {
    case CHANGE_FILTER:
      return {
        ...state,
        [action.filter]: action.value,
      }
    case RESET_FILTERS:
      return {
        ...state,
        ...initialFilters,
        status: state.defaultStatusFilters || [],
      }
    case FETCH_INITIAL_DATA_RECEIVED:
      return {
        ...state,
        ...action.data.filters,
        defaultStatusFilters: action.data.filters.status || [],
      }
    default:
      return state
  }
}
export default filters